import { useHistory, useLocation as useClientLocation } from "react-router-dom";
import { useCallback } from "react";
import useSSRLocation from "./useSSRLocation";
import {isServer} from "../constants/isServer";
const useLocation = isServer ? useSSRLocation : useClientLocation;
const useQueryParamsController = () => {
  const history = useHistory();
  const location = useLocation();
  //@ts-ignore
  window.customHistory = history;

  const { pathname, search, hash} = location;
  // @ts-ignore
  return useCallback((params, config = {}) => {
    const currentUrlParams = new URLSearchParams(search);
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        currentUrlParams.set(key, value as string);
      } else {
        currentUrlParams.delete(key)
      }
    })
    // @ts-ignore
    const action = config?.replace ? 'replace' : 'push';
    history[action](`${pathname}?${currentUrlParams.toString()}${hash}`);
  },[history, pathname, search, hash]);
}

export default useQueryParamsController;import { useHistory, useLocation as useClientLocation } from "react-router-dom";
import { useCallback } from "react";
import useSSRLocation from "./useSSRLocation";
import {isServer} from "../constants/isServer";
const useLocation = isServer ? useSSRLocation : useClientLocation;
const useQueryParamsController = () => {
  const history = useHistory();
  const location = useLocation();
  //@ts-ignore
  window.customHistory = history;

  const { pathname, search, hash} = location;
  // @ts-ignore
  return useCallback((params, config = {}) => {
    const currentUrlParams = new URLSearchParams(search);
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        currentUrlParams.set(key, value as string);
      } else {
        currentUrlParams.delete(key)
      }
    })
    // @ts-ignore
    const action = config?.replace ? 'replace' : 'push';
    history[action](`${pathname}?${currentUrlParams.toString()}${hash}`);
  },[history, pathname, search, hash]);
}

export default useQueryParamsController;